import { render, staticRenderFns } from "./MyAssignmentOfferExcerpt.vue?vue&type=template&id=ca410082&scoped=true&"
import script from "./myAssignmentOfferExcerpt.js?vue&type=script&lang=js&"
export * from "./myAssignmentOfferExcerpt.js?vue&type=script&lang=js&"
import style0 from "./MyAssignmentOfferExcerpt.vue?vue&type=style&index=0&id=ca410082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca410082",
  null
  
)

export default component.exports